export default __webpack_public_path__ + "3a04935ad23d82305ab281a118f8c306.svg";